module.exports = " <div class=show_custom> <div class=showCityandRule-1> <p class=th> <span>{{introtit}}</span> <img src=//static.daojia.com/fe/jz/daojiaapp/hongbao/image/guide-title.eb435f99.png alt=\"\"> <em @click=hideEvent></em> </p> <div class=wrapper> <pre>{{intro}}</pre> <a href=javascript:; class=know @click=hideEvent>我知道了</a> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/About.vue
// module id = 142
// module chunks = 0